import { render, staticRenderFns } from "./WaterSources.vue?vue&type=template&id=d8d5706a"
import script from "./WaterSources.vue?vue&type=script&lang=js"
export * from "./WaterSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports